import React from "react";
import { useLocation, useNavigate } from 'react-router-dom';
import AdminExportExcelByVpsComponent from "../../../../components/Admin/vps/AdminExportExcelByVpsComponent";

const AdminExportExcelVpsPage = () => {
    const { search } = useLocation();
    const navigate = useNavigate();

    let redirectBack = () => {
        navigate(-1);
    }

    return <AdminExportExcelByVpsComponent
        redirectBack={ () => redirectBack() }
        listVpsId={ new URLSearchParams(search).get('listVpsId') }
    />
}

export default AdminExportExcelVpsPage;